<template>
  <Transition name="fade" v-clock>
    <component v-if="isMobile" :is="MobileComponent" lazy />
    <Pc v-else lazy />
  </Transition>
</template>

<script>
import { mapGetters } from 'vuex';
import Pc from '@/components/PcModule.vue';

export default {
  name: 'App',
  data() {
    return {
      isRouterAlive: true,
      MobileComponent: null,
      isMobile: false,
    };
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  computed: {
    ...mapGetters(['innerHeightRem']),
  },
  components: {
    Pc,
  },
  created() {
    this.checkDeviceType();
  },
  methods: {
    checkDeviceType() {
      const userAgent = navigator.userAgent;
      const viewportWidth = window.innerWidth;
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      const mobileKeywords = [
        'Android', 'webOS', 'iPhone', 'iPad', 'iPod', 'BlackBerry',
        'Windows Phone', 'Mobile', 'Tablet',
      ];

      const isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword)) ||
        (isTouchDevice && viewportWidth < 768);

      this.isMobile = isMobile;

      if (this.isMobile) {
        this.loadMobileComponent();
      } else {
        // 如果不是移动设备，导入相关样式
        import('@/styles/style.css');
      }
    },
    async loadMobileComponent() {
      // 导入移动相关样式
      await Promise.all([
        import('@/styles/mobile.css'),
        import('@/styles/reset.css'),
      ]);
      // 异步加载移动组件
      this.MobileComponent = (await import('@/components/MobileModule.vue')).default;
    },
  },
} 
</script>